import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star } from 'lucide-react';
export function CostOfInaction() {
  const situations = [{
    icon: '✔',
    text: 'Investigación basada en fuentes históricas.'
  }, {
    icon: '✔',
    text: 'Narración clara y fácil de leer.'
  }, {
    icon: '✔',
    text: 'Ideal para quienes disfrutan de la historia y la mitología.'
  }, {
    icon: '✔',
    text: 'Acceso inmediato.'
  }, {
    icon: '✔',
    text: 'Compatible con computadora, tablet y celular.'
  }, {
    icon: '✔',
    text: 'Descarga en formato PDF.'
  }, {
    icon: '✔',
    text: 'Acceso de por vida.'
  }];
  return <section className="py-20 md:py-32 px-4" data-id="element-37">
      <div className="max-w-4xl mx-auto" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-39">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-40">
            ¿Por qué elegir esta colección?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-41">
          {situations.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-card border border-dark-border p-6 rounded-xl flex items-start gap-4 hover:border-gold/30 transition-colors" data-id="element-42">
              <span className="text-3xl" data-id="element-43">{item.icon}</span>
              <p className="text-gray-300 text-lg leading-relaxed mt-1" data-id="element-44">
                {item.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}